import {BaseService} from '../base-service/base.service';
import {Injectable} from '@angular/core';
import {firstValueFrom, Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {map} from 'rxjs/operators';
import {MessageAlertService} from '../message-alert/message-alert.service';
import {IMediaResource} from '../../interfaces/media-resource/media-resource.interface';
import {UtilitiesService} from '../utilities-service/utilities.service';

@Injectable({
  providedIn: 'root',
})
export class UploadFileService {
  constructor(
    public baseService: BaseService<any>,
    private alertService: MessageAlertService,
    private utilitiesService: UtilitiesService
  ) { }

  url = environment.SERVER_URL;

  async postFile(file: File, path: string, extensions: string[] = []): Promise<IMediaResource> {
    const fd = new FormData();
    fd.append('file', file);
    // Validar extensión si se le pasa arreglo de extensiones
    const validationExtension = this.utilitiesService.validateExtensionImage(file, extensions, extensions.length > 0);
    if (extensions.length > 0 && !validationExtension) {
      throw new Error('Invalid extension');
    }
    // Enviar solicitud al servidor
    const response = await firstValueFrom(this.baseService.post(`${this.url}/${path}`, fd, {}, '', {
      'Content-Type': 'multipart/form-data'
    }));
    if (response.error) {
      throw new Error(response.message);
    } else {
      return response.entity;
    }
  }

  getFile(key: string): Observable<File> {
    return this.baseService
      .get(`${this.url}/files/${key}`)
      .pipe(map((value) => value.entity));
  }

  getFileLink(key: string): Observable<string> {
    return this.baseService
      .get(`${this.url}/files/private/${key}`)
      .pipe(map((value) => value.entity));
  }

  deleteFile(key: string): Observable<any> {
    return this.baseService
      .delete(`${this.url}/files/${key}`);
  }
}
